export default "__VITE_ASSET__CzC9qkyI__"